import { useQuery } from '@tanstack/react-query';
import { syncConfigService } from '../services/product-client-sync-config.service';

export function useProductClientSyncConfig(productId: number | null) {
  return useQuery({
    queryKey: ['product-client-sync-config', productId],
    queryFn: () => syncConfigService.get(productId as number),
    enabled: !!productId,
  });
}
